import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import App from './App';
export const renderApp = (config) => {
    const mountNode = document.getElementById('custom');
    const root = ReactDOM.createRoot(mountNode);
    root.render(_jsx(App, {}));
};
